import React from 'react';

export default function Welcome() {
  return (
    <div className="min-h-screen bg-slate-50 text-slate-800 flex flex-col justify-between">
      {/* Header */}
      <header className="border-b border-slate-200 bg-white/80 backdrop-blur-md sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <span className="text-xl font-extrabold tracking-tight text-blue-600">
              DCA PRO
            </span>
          </div>
          <nav className="flex items-center gap-6">
            <a 
              href="/manual/" 
              className="text-sm font-semibold text-slate-600 hover:text-slate-900 transition-colors"
            >
              Manual
            </a>
            <a 
              href="/dca" 
              className="text-sm font-bold px-4 py-2 bg-blue-600 rounded-xl text-white hover:bg-blue-700 active:scale-95 transition-all"
            >
              Go to App
            </a>
          </nav>
        </div>
      </header>

      {/* Hero Section */}
      <main className="flex-1 flex flex-col items-center justify-center px-6 py-20 text-center max-w-4xl mx-auto">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-blue-50 border border-blue-100 text-[11px] font-bold text-blue-600 uppercase tracking-wider mb-8">
          🚀 High Performance Algo Trading
        </div>
        
        <h1 className="flex flex-col items-center leading-tight mb-6">
          <span className="text-sm sm:text-base font-bold text-slate-500 uppercase tracking-widest mb-2">
            Crypto 자동 매매
          </span>
          <span className="text-5xl sm:text-6xl font-black text-blue-600 tracking-tight">
            DCA PRO
          </span>
        </h1>
        
        <p className="text-slate-600 text-base sm:text-lg max-w-2xl leading-relaxed mb-10">
          고성능 Fiber Pool 기반의 실시간 봇 엔진과 자율형 스캐너로 암호화폐 선물 시장의 변동성을 효과적으로 공략합니다. 정교한 분할 매수 및 다중 전략 엔진을 지금 바로 경험해 보세요.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 w-full justify-center">
          <a
            href="/dca"
            className="px-8 py-3.5 bg-blue-600 text-white font-bold rounded-xl hover:bg-blue-700 active:scale-95 transition-all shadow-md shadow-blue-500/10"
          >
            대시보드 시작하기
          </a>
          <a
            href="/manual/"
            className="px-8 py-3.5 bg-white hover:bg-slate-100 border border-slate-200 text-slate-700 font-bold rounded-xl active:scale-95 transition-all"
          >
            매뉴얼 살펴보기
          </a>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-slate-200 bg-white py-6">
        <div className="max-w-7xl mx-auto px-6 text-center text-xs text-slate-500 font-semibold">
          © {new Date().getFullYear()} DCA PRO. All rights reserved.
        </div>
      </footer>
    </div>
  );
}
